let countdownInterval;
export function showPlayNextScreenIfNeeded(overlayDuration, containerEl, proceedCallBack) {
    const playnextOverlay = containerEl.querySelector('.bmpui-overlay-playnext');
    if (playnextOverlay?.classList.contains('show'))
        return;
    clearInterval(countdownInterval);
    playnextOverlay?.classList.add('show');
    const playNextButton = playnextOverlay?.querySelector('.ui-playNextButton');
    if (playNextButton) {
        playNextButton.style.setProperty('--animation-duration', `${overlayDuration}s`);
        playNextButton.focus();
    }
    let countdown = overlayDuration - 1;
    countdownInterval = window.setInterval(() => {
        if (playnextOverlay?.classList.contains('show')) {
            countdown--;
            if (countdown < 0) {
                clearInterval(countdownInterval);
                proceedCallBack?.();
                playnextOverlay?.classList.remove('show');
            }
        }
    }, 1000);
}
export function hidePlayNextScreen(containerEl) {
    clearInterval(countdownInterval);
    containerEl.querySelector('.bmpui-overlay-playnext')?.classList.remove('show');
}
